import styled, {css} from 'styled-components';
import {palette} from 'styled-theme';
import {borderRadius, boxShadow, transition} from '../../settings/style-util';
import WithDirection from '../../settings/withDirection';

const TopbarWrapper = styled.div`
  /* stylelint-disable no-descending-specificity */

  .isomorphicTopbar {
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    padding: ${props => (props['data-rtl'] === 'rtl' ? '0 15px 0 31px' : '0 31px 0 15px')};
    background-color: #fff;
    border-bottom: 1px solid rgba(0, 0, 0, 10%);

    /* position: absolute !important; */
    
    ${transition()};

    /* &.update-available {
      background: #ffccc7;
    } */
    
    @media only screen and (width >= 767px) {
      width: calc(100% - 240px) !important;
      margin-left: 240px;
    }
    
    @media only screen and (width <= 767px) {
      padding: ${props => (props['data-rtl'] === 'rtl'
        ? '0px 15px !important'
        : '0px 15px !important')};
      margin-left: 240px;
    }

    &.collapsed {
      @media only screen and (width >= 767px) {
        width: calc(100% - 70px) !important;
        padding: ${props => (props['data-rtl'] === 'rtl' ? '0 39px 0 31px' : '0 31px 0 39px')};
        margin-left: 70px;
      }

      @media only screen and (width <= 767px) {
        padding: ${props => (props['data-rtl'] === 'rtl'
        ? '0px 15px !important'
        : '0px 15px !important')};
        margin-left: 0;
      }
    }

    .isoLeft {
      display: flex;
      align-items: center;

      @media only screen and (width <= 767px) {
        margin: ${props => (props['data-rtl'] === 'rtl' ? '0 0 0 20px' : '0 20px 0 0')};
      }

      .update-text {
        padding-left: 24px;

        .anticon {
          font-size: 22px;
          vertical-align: middle;
        }
      }

      .triggerBtn {
        position: relative;
        display: -ms-inline-flex;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 24px;
        height: 100%;
        cursor: pointer;
        background-color: transparent;
        border: 0;
        outline: 0;

        &::before {
          position: absolute;
          /* stylelint-disable-next-line font-family-no-missing-generic-family-keyword */
          font-family: Ionicons;
          font-size: 26px;
          line-height: 0;
          color: inherit;
          content: '\f20e';
        }
      }
    }

    .isoRight {
      display: flex;
      align-items: center;

      li {
        position: relative;
        display: inline-block;
        margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '35px')};
        margin-left: ${props => (props['data-rtl'] === 'rtl' ? '35px' : '0')};
        line-height: normal;
        cursor: pointer;

        @media only screen and (width <= 360px) {
          margin-right: ${props => (props['data-rtl'] === 'rtl' ? '0' : '25px')};
          margin-left: ${props => (props['data-rtl'] === 'rtl' ? '25px' : '0')};
        }

        &:last-child {
          margin: 0;
        }

        .anticon {
          font-size: 24px;
          line-height: 1;
          color: ${palette('text', 0)};
        }

        .isoIconWrapper {
          position: relative;
          line-height: normal;

          span {
            position: absolute;
            top: -8px;
            right: ${props => (props['data-rtl'] === 'rtl' ? '10px' : 'inherit')};
            left: ${props => (props['data-rtl'] === 'rtl' ? 'inherit' : '10px')};
            display: -ms-inline-flex;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 20px;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            color: #fff;
            text-align: center;
            background-color: ${palette('secondary', 1)};
            ${borderRadius('50%')};
          }
        }

        &.isoMail {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 0)};
            }
          }
        }

        &.isoNotify {
          .isoIconWrapper {
            span {
              background-color: ${palette('primary', 2)};
            }
          }
        }

        &.isoMsg {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 1)};
            }
          }
        }

        &.isoCart {
          .isoIconWrapper {
            span {
              background-color: ${palette('color', 2)};
            }
          }
        }

        &.isoUser {
          .isoImgWrapper {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 40px;
            height: 40px;
            background-color: ${palette('grayscale', 9)};
            ${borderRadius('50%')};

            img {
              height: 100%;
              object-fit: cover;
            }

            .userActivity {
              position: absolute;
              right: 3px;
              bottom: 0;
              display: block;
              width: 10px;
              height: 10px;
              background-color: ${palette('color', 3)};
              border: 1px solid #fff;
              ${borderRadius('50%')};
            }
          }
        }
      }
    }
  }

  .isoUserDropdown {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoUserDropdownContent {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          width: 220px;
          min-width: 160px;
          padding: 7px 0;
          background-color: #fff;

          /* .isoBorderRadius(5px); */
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          .isoDropdownLink {
            display: flex;
            justify-content: flex-start;
            padding: 7px 15px;
            font-size: 13px;
            line-height: 1.1;
            color: ${palette('text', 1)};
            text-decoration: none;
            background-color: transparent;
            ${transition()};

            &:hover {
              background-color: ${palette('secondary', 6)};
            }
          }
        }
      }
    }
  }

  /* Dropdown */
  .ant-popover {
    .ant-popover-inner {
      .ant-popover-inner-content {
        .isoDropdownContent {
          position: absolute;
          top: 0;
          right: 0;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          width: 360px;
          min-width: 160px;
          background-color: #fff;
          ${borderRadius('5px')};
          ${boxShadow('0 2px 10px rgba(0,0,0,0.2)')};
          ${transition()};

          @media only screen and (width <= 767px) {
            width: 310px;
          }

          .isoDropdownHeader {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 15px 30px;
            margin-bottom: 0;
            border-bottom: 1px solid #f1f1f1;

            h3 {
              margin: 0;
              font-size: 14px;
              font-weight: 500;
              color: ${palette('text', 0)};
              text-align: center;
              text-transform: uppercase;
            }
          }

          .isoDropdownBody {
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 300px;
            margin-bottom: 10px;
            overflow-y: auto;
            background-color: ${palette('grayscale', 6)};

            .isoDropdownListItem {
              display: flex;
              flex-direction: column;
              flex-shrink: 0;
              width: 100%;
              padding: 15px 30px;
              text-decoration: none;
              ${transition()};

              &:hover {
                background-color: ${palette('grayscale', 3)};
              }

              .isoListHead {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5px;
              }

              h5 {
                margin-top: 0;
                font-size: 13px;
                font-weight: 500;
                color: ${palette('text', 0)};
              }

              p {
                overflow: hidden;
                font-size: 12px;
                font-weight: 400;
                color: ${palette('text', 2)};
                text-overflow: ellipsis;
                white-space: nowrap;
              }

              .isoDate {
                flex-shrink: 0;
                font-size: 11px;
                color: ${palette('grayscale', 1)};
              }
            }
          }

          .isoViewAllBtn {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 15px 20px;
            font-size: 13px;
            font-weight: 500;
            color: ${palette('text', 2)};
            text-align: center;
            text-decoration: none;
            ${transition()};

            &:hover {
              color: ${palette('primary', 0)};
            }
          }

          .isoDropdownFooterLinks {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 30px 20px;

            a {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px 20px;
              font-size: 13px;
              font-weight: 500;
              line-height: 1;
              color: ${palette('text', 0)};
              text-decoration: none;
              border: 1px solid ${palette('border', 1)};
              ${transition()};

              &:hover {
                color: #fff;
                background-color: ${palette('primary', 0)};
                border-color: ${palette('primary', 0)};
              }
            }

            h3 {
              font-size: 14px;
              font-weight: 500;
              line-height: 1.3;
              color: ${palette('text', 0)};
            }
          }

          &.withImg {
            .isoDropdownListItem {
              display: flex;
              flex-direction: row;

              .isoImgWrapper {
                display: -ms-inline-flex;
                display: inline-flex;
                flex-shrink: 0;
                align-items: center;
                justify-content: center;
                width: 35px;
                height: 35px;
                margin-right: 15px;
                overflow: hidden;
                background-color: ${palette('grayscale', 9)};
                ${borderRadius('50%')};

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                }
              }

              .isoListContent {
                display: flex;
                flex-direction: column;
                width: 100%;

                .isoListHead {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  margin-bottom: 10px;
                }

                h5 {
                  padding-right: 15px;
                  margin-bottom: 0;
                }

                .isoDate {
                  flex-shrink: 0;
                  font-size: 11px;
                  color: ${palette('grayscale', 1)};
                }

                p {
                  line-height: 1.5;
                  white-space: normal;
                }
              }
            }
          }
        }
      }
    }

    &.topbarMail {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (width <= 519px) {
              right: -170px;
            }
          }
        }
      }
    }

    &.topbarMessage {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (width <= 500px) {
              right: -69px;
            }
          }
        }
      }
    }

    &.topbarNotification {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (width <= 500px) {
              right: -120px;
            }
          }
        }
      }
    }

    &.topbarAddtoCart {
      .ant-popover-inner {
        .ant-popover-inner-content {
          .isoDropdownContent {
            @media only screen and (width <= 465px) {
              right: -55px;
            }

            .isoDropdownHeader {
              margin-bottom: 0;
            }

            .isoDropdownBody {
              background-color: ${palette('grayscale', 6)};
            }
          }
        }
      }
    }
  }
`;

export const TopbarStyled = css`

`;

export default WithDirection(TopbarWrapper);
